import {
  QuestHistory as GraphqlQuestHistory,
  OwnerQuest as GraphqlQuest,
  Quest as GraphqlPublicQuest,
  Symbol as GraphqlQuestSymbol,
} from 'vvs-gotchi-graphql'

export type QuestHistory = {
  questSymbol: QuestSymbol
  earnedExp: number
  completedAt: number
}

export type Quest = {
  symbol: QuestSymbol
  exp?: number
  isCompleted?: boolean
}

export enum QuestSymbol {
  ADOPT = 'ADOPT',
  TEAM_UP = 'TEAM_UP',
  BARTER = 'BARTER',
  MOLE_OPOLY = 'MOLE_OPOLY',
  HYDRATE = 'HYDRATE',
  PROFIT = 'PROFIT',
  SOCIALISE = 'SOCIALISE',
  FARM = 'FARM',
  GOLD_DIGGER = 'GOLD_DIGGER',
  GACHA = 'GACHA',
  MOLE_DASH = 'MOLE_DASH',
}

export const questHistoryFromGraphqlData = (data: GraphqlQuestHistory): QuestHistory => {
  return {
    questSymbol: questSymbolFromGraphqlDataMap[data.symbol],
    earnedExp: data.earnedExp,
    completedAt: data.completedAt,
  }
}

export const questFromGraphqlData = (data: GraphqlQuest): Quest => {
  return {
    symbol: questSymbolFromGraphqlDataMap[data.symbol],
    exp: data.exp,
    isCompleted: data.isCompleted,
  }
}

export const publicQuestFromGraphqlData = (data: GraphqlPublicQuest): Quest => {
  return {
    symbol: questSymbolFromGraphqlDataMap[data.symbol],
    exp: null,
    isCompleted: false,
  }
}

export const questSymbolFromGraphqlDataMap: Record<GraphqlQuestSymbol, QuestSymbol> = {
  ADOPT: QuestSymbol.ADOPT,
  TEAM_UP: QuestSymbol.TEAM_UP,
  BARTER: QuestSymbol.BARTER,
  MOLE_OPOLY: QuestSymbol.MOLE_OPOLY,
  HYDRATE: QuestSymbol.HYDRATE,
  PROFIT: QuestSymbol.PROFIT,
  FARM: QuestSymbol.FARM,
  GOLD_DIGGER: QuestSymbol.GOLD_DIGGER,
  GACHA: QuestSymbol.GACHA,
  MOLE_DASH: QuestSymbol.MOLE_DASH,
  // SOCIALISE: QuestSymbol.SOCIALISE,
}

/**
 * FE side quest config
 */
export type QuestConfig = {
  name: string
  description?: string
  category: QuestCategory
  type?: QuestType
  frequency?: QuestFrequency
  variableExpRules?: VariableExpRule[]
}

export type QuestWithConfig = Quest & QuestConfig
export type QuestHistoryWithConfig = QuestHistory & QuestConfig
export type QuestConfigsRecord = Record<QuestSymbol, QuestConfig>

export enum QuestCategory {
  ONBOARDING,
  MOLE_CARE,
  DAILY_WORK,
  SPECIAL_MISSION,
  GAME_CHALLENGES,
}
export enum QuestType {
  SWAP,
  XVVS,
  LIQUIDITY,
  FARM,
  LIMIT_ORDER,
  FLASH_LP,
  IGO,
}
export enum QuestFrequency {
  ONE_TIME_ONLY,
  UNLIMITED,
  ONCE_A_DAY,
  EVENT_DRIVEN,
}
export type VariableExpRule = {
  cumulativeUsd: { from: number; to?: number }
  expPerUsd: number
}
